import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalInvestigationsIssuesModel } from './types';
import { legalInvestigationsDeniedItemValidator, legalInvestigationsSuspendedItemValidator } from './validators/item';
import { legalInvestigationsRevokedItemValidator } from '../revoked/validators/item';

const legalInvestigationsIssuesValidator: ValidateJSModel<LegalInvestigationsIssuesModel> = {
  HasRevocations: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },
  List: (value, attributes) => {
    if (attributes?.HasRevocations && attributes?.HasRevocations.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalInvestigationsRevokedItemValidator },
      };
    }

    return {};
  },
  HasDenials: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },
  DenialList: (value, attributes) => {
    if (attributes?.HasDenials && attributes?.HasDenials.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalInvestigationsDeniedItemValidator },
      };
    }

    return {};
  },
  HasSuspensions: {
    presence: true,
    hasValue: { validator: hasYesOrNo },
  },
  SuspensionList: (value, attributes) => {
    if (attributes?.HasSuspensions && attributes?.HasSuspensions.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: legalInvestigationsSuspendedItemValidator },
      };
    }

    return {};
  },
};
export default legalInvestigationsIssuesValidator;
